<p>custom-palette-page works!</p>
file://tahl.com/ta/IT%20Shared/WEB%20Project/NewWebsite2019/PSD-HTML/Custom_Palette_Program.html
file://tahl.com/ta/IT%20Shared/WEB%20Project/NewWebsite2019/PSD-HTML/Custom_Uphostery.html
